var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1990",
    "data-name": "Rectangle 1990",
    width: 25,
    height: 25,
    transform: "translate(-8985 1760)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_185",
    "data-name": "Mask Group 185",
    transform: "translate(8985 -1760)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19845",
    "data-name": "Group 19845",
    transform: "translate(-10183.62 1225.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19844",
    "data-name": "Group 19844",
    transform: "translate(1200.773 535.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15339",
    "data-name": "Path 15339",
    d: "M1211.125,561.426a7.963,7.963,0,0,0,7.653-5.612,8.183,8.183,0,0,0-3.215-9.149c-.117-.082-.239-.158-.358-.239-.67-.453-.863-1.006-.537-1.534a1.256,1.256,0,0,1,1.75-.382,9.867,9.867,0,0,1,2.915,2.6,10.345,10.345,0,1,1-13.608-2.555,1.223,1.223,0,0,1,1.405-.1,1.085,1.085,0,0,1,0,1.906,13.44,13.44,0,0,0-1.812,1.509,8.017,8.017,0,0,0,4.736,13.489A10.548,10.548,0,0,0,1211.125,561.426Z",
    transform: "translate(-1200.773 -540.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15340",
    "data-name": "Path 15340",
    d: "M1226.386,540.486c0,1.308.011,2.616,0,3.924-.009.817-.428,1.242-1.164,1.238a1.079,1.079,0,0,1-1.144-1.2c-.019-.949-.006-1.9-.006-2.849,0-1.667-.009-3.333,0-5a1.145,1.145,0,0,1,1.56-1.208c.5.162.747.543.751,1.227C1226.392,537.905,1226.386,539.2,1226.386,540.486Z",
    transform: "translate(-1214.889 -535.314)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.2603b5c1c1acce9557ee848ba697f88d.svg";
export { ForwardRef as ReactComponent };